import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Layout from '@/components/layout';
import { useAuth } from '@/lib/auth';
import AccessoriesPage from '@/pages/accessories';
import AuditPage from '@/pages/audit';
import AvailabilityPage from '@/pages/availability';
import BannersPage from '@/pages/banners';
import CategoriesPage from '@/pages/categories';
import CustomersPage from '@/pages/customers';
import ChangePasswordPage from '@/pages/change-password';
import DashboardPage from '@/pages/dashboard';
import DictionariesPage from '@/pages/dictionaries';
import LoginPage from '@/pages/login';
import OrdersPage from '@/pages/orders';
import PaymentsPage from '@/pages/payments';
import NotificationsPage from '@/pages/notifications';
import ReturnsPage from '@/pages/returns';
import ProductEditorPage from '@/pages/product-editor';
import ProductsPage from '@/pages/products';
import PromoPage from '@/pages/promo';
import SettingsPage from '@/pages/settings';
import StaffPage from '@/pages/staff';

export default function App() {
  const { status, admin } = useAuth();

  if (status === 'loading') {
    return (
      <div className="flex min-h-full items-center justify-center">
        <p className="text-sm text-neutral-500">Загрузка…</p>
      </div>
    );
  }

  if (status === 'anonymous') return <LoginPage />;

  // Пока пароль по умолчанию не сменён, в панель не пускаем
  if (admin?.mustChangePassword) return <ChangePasswordPage />;

  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/categories" element={<CategoriesPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/products/:id" element={<ProductEditorPage />} />
          <Route path="/accessories" element={<AccessoriesPage />} />
          <Route path="/orders" element={<OrdersPage />} />
          <Route path="/payments" element={<PaymentsPage />} />
          <Route path="/returns" element={<ReturnsPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/availability" element={<AvailabilityPage />} />
          <Route path="/dictionaries" element={<DictionariesPage />} />
          <Route path="/promo" element={<PromoPage />} />
          <Route path="/customers" element={<CustomersPage />} />
          <Route path="/banners" element={<BannersPage />} />
          <Route path="/staff" element={<StaffPage />} />
          <Route path="/audit" element={<AuditPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}
